import { IDataCityResourceShortProps } from '../../../props/data/geographics/cities';
import Request from './../../request';

// import props

const DataCityService = {
    retrieve: async (qs?: string): Promise<IDataCityResourceShortProps[]> => {
        try {
            const results = await Request.get(`/api/data/geographics/cities?${qs || ""}`);
            return results;
        } catch (e) {
            throw (e);
        }
    }
};

export default DataCityService;